import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { ChangePasswordModel } from "../models/changePassword.model";
import { Formik } from "formik";
import * as yup from 'yup';
import { ResultRequestModel } from "../models/resultRequest.model";
import { ToastService } from "../services/toast.service";
import { UserService } from "../services/user.service";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

export const ModalChangePassword = (props: any) => {
    const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const changePasswordRequest = (model: ChangePasswordModel) => {
    UserService
      .setNewPassword(model)
      .then((response: ResultRequestModel) => {
        if (response.success) {
          ToastService.success(t("SUCCESS_RECOVER_PASSWORD"));
          props.close();
        }
      }).catch((e: any) => {
        ToastService.error(t('ERROR_GENERIC'));
      }).finally(() => {
        setLoading(false);        
      });
  }

  const initialValuesChangePassword: ChangePasswordModel = {
    oldPassword: '',
    newPassword: '',
    newPassword2: ''
  };

  const schemaChangePassword = yup.object().shape({
    oldPassword: yup.string().required(t('REQUIRED')),
    newPassword2: yup.string().required(t('REQUIRED')).oneOf([yup.ref('newPassword'), null], t('PASSWORD_VALIDATION_MATCH'))
  });
  return (
      <Modal as={Modal.Dialog} centered show={props.show} onHide={props.close}>
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={props.close} />
        </Modal.Header>
        <Modal.Body>
        <Formik
            initialValues={initialValuesChangePassword}
            validationSchema={schemaChangePassword}
            onSubmit={(values, actions) => {
              changePasswordRequest(values);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              touched,
              isValid,
              errors,
            }) => (
            <Form noValidate onSubmit={handleSubmit}>
                <Form.Floating className="mb-4">
                  <Form.Control
                    id="oldPassword"
                    name="oldPassword"
                    type="password"
                    onChange={handleChange}
                    value={values?.oldPassword}
                    isInvalid={!!touched.oldPassword && !!errors.oldPassword}
                    placeholder={t("OLD_PASSWORD")}        
                    disabled={isLoading}        
                  />
                  <label htmlFor="oldPassword">{t("OLD_PASSWORD")}</label>
                  <Form.Control.Feedback type="invalid">
                    {errors.oldPassword}
                  </Form.Control.Feedback>
                </Form.Floating>
                <Form.Floating className="mb-4">
                  <Form.Control
                    id="newPassword"
                    name="newPassword"
                    type="password"
                    value={values?.newPassword}
                    onChange={handleChange}
                    isInvalid={!!touched.newPassword && !!errors.newPassword}
                    placeholder={t("NEW_PASSWORD")}   
                    disabled={isLoading}             
                  />
                  <label htmlFor="newpassword">{t("NEW_PASSWORD")}</label>
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword}
                  </Form.Control.Feedback>
                </Form.Floating>
                <Form.Floating className="mb-4">
                  <Form.Control
                    id="newPassword2"
                    name="newPassword2"
                    type="password"
                    value={values?.newPassword2}
                    onChange={handleChange}
                    isInvalid={!!touched.newPassword2 && !!errors.newPassword2}
                    placeholder={t("CONFIRM_NEW_PASSWORD")}  
                    disabled={isLoading}              
                  />
                  <label htmlFor="newpassword2">{t("CONFIRM_NEW_PASSWORD")}</label>
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword2}
                  </Form.Control.Feedback>
                </Form.Floating>

                <Button
                    variant="primary"
                    type="submit"
                    disabled={isLoading}
                    >
                    <>
                        {isLoading &&
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        }
                            {t("PASSWORD_CHANGE")}
                    </>
                </Button>
             
            </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
  );
};
